import {get, post, upload} from '@/utils/request'

const SUPPLIER_URL = '/supplier-service/v1'
// const WORKFLOW_URL = '/workflow-service/v1'

export function listSupplierInvite(params) {return post(SUPPLIER_URL + '/supplierInvite/list', params)}
// 新建供应商
export function createSupplier(params) {return post(SUPPLIER_URL + '/supplierInvite/create', params)}
export function saveToMtl(params) {return post(SUPPLIER_URL + '/supplierInvite/saveToMtl', params)}
// 修改邀请供应商
export function updateSupplier(params) {return post(SUPPLIER_URL + '/supplierInvite/update', params)}
// 邀请供应商
export function inviteSupplier(params) {return post(SUPPLIER_URL + '/supplierInvite/invite', params)}
// 撤回供应商邀请
export function inviteRecall(params) {return post(SUPPLIER_URL + '/supplierInvite/inviteRecall', params)}
// 根据ID查询邀请供应商
export function supplierInviteById(params) {return get(SUPPLIER_URL + '/supplierInvite/supplierInviteById', params)}
// 删除邀请供应商
export function deleteInviteSupplier(params) {return get(SUPPLIER_URL + '/supplierInvite/deleteInviteSupplier', params)}

//supplierInvite/createUse
export function createUse(params) {return post(SUPPLIER_URL + '/supplierInvite/createUse', params)}

// 查询审批
export function listApplyForm(params) {return post(SUPPLIER_URL + '/admissionApplyForm/list', params)}
// 潜在审批
export function execTask(params) {return post(SUPPLIER_URL + '/admissionApplyForm/executeApprove', params)}
// 合格审批
export function execTask2(params) {return post(SUPPLIER_URL + '/admissionApplyForm/executeApprove2', params)}


export function finishProcess(params) {return post(SUPPLIER_URL + '/admissionApplyForm/executeFinish', params)}

/** 供应商档案管理 */
// 供应商档案分页查询
export function selectSupplierPage(params) {return post(SUPPLIER_URL + '/supplierInfo/selectSupplierPage', params)}
// 根据ID查询供应商档案
export function selectSupplierById(params) {return get(SUPPLIER_URL + '/supplierInfo/selectSupplierById', params)}
// 根据ID修改供应商档案
export function updateSupplierById(params) {return post(SUPPLIER_URL + '/supplierInfo/updateSupplierById', params)}
// 根据ID删除供应商档案
export function deleteSupplierById(params) {return get(SUPPLIER_URL + '/supplierInfo/deleteSupplierById', params)}
// 供应商冻结或解冻
export function frozenThaw(params) {return post(SUPPLIER_URL + '/supplierInfo/frozenThaw', params)}
// 供应商维护
export function mainTain(params) {return post(SUPPLIER_URL + '/supplierInfo/mainTain', params)}
// 上传文件
export function supplierUpload(params) {return upload(SUPPLIER_URL + '/supplierInfo/upload', params)}
// 冻结解冻审批分页查询
export function selectApplyFormPage(params) {return post(SUPPLIER_URL + '/freezingThawApplyForm/selectApplyFormPage', params)}
// 冻结解冻执行审批
export function executeApprove(params) {return post(SUPPLIER_URL + '/freezingThawApplyForm/executeApprove', params)}
// 查询文件列表
export function selectFileList(params) {return get(SUPPLIER_URL + '/supplierInfo/selectFileList',params)}
// 获取文件下载路径
export function getFileURL(params) {return get(SUPPLIER_URL + '/supplierInfo/getFileURL',params)}
// 合格邀约
export function qualifiedInvite(params) {return post(SUPPLIER_URL + '/supplierInfo/qualifiedInvite',params)}
export function changeSubLevel(params) {return post(SUPPLIER_URL + '/supplierInfo/changeSubLevel',params)}
// 新建一次性供应商
export function createDisposableSupplier(params) {return post(SUPPLIER_URL + '/supplierInfo/createDisposableSupplier', params)}


/** 供应商基本信息 */
// 通过供应商ID获取供应商信息
export function getSupplieInfo1(params) {return get(SUPPLIER_URL + '/supplierInfo/getSupplierBasicInfoById', params)}
// 通过供应商ID获取供应商联系人
export function getSupplieInfo2(params) {return post(SUPPLIER_URL + '/supplierInfo/listSupplierContracts', params)}
// 通过供应商ID获取工厂及地址
export function getSupplieInfo3(params) {return post(SUPPLIER_URL + '/supplierInfo/listSupplierFactories', params)}
// 通过供应商ID获取企业经营状况
export function getSupplieInfo4(params) {return post(SUPPLIER_URL + '/supplierInfo/listSupplierBusinessYears', params)}
// 通过供应商ID获取体系认证情况
export function getSupplieInfo5(params) {return post(SUPPLIER_URL + '/supplierInfo/listSupplierCertifications', params)}
// 通过供应商ID获取主要产品目录
export function getSupplieInfo6(params) {return post(SUPPLIER_URL + '/supplierInfo/listSupplierProducts', params)}
// 通过供应商ID获取主要设备清单
export function getSupplieInfo7(params) {return post(SUPPLIER_URL + '/supplierInfo/listSupplierEquipments', params)}
// 通过供应商ID获取附件
export function getSupplieInfo8(params) {return get(SUPPLIER_URL + '/supplierInfo/getBasicInfoFiles', params)}
// 通过供应商ID获取附件
export function selectSupplierPage2(params) {return post(SUPPLIER_URL + '/supplierInfo/selectSupplierPage2', params)}

// 测试SAP
export function testSap(params) {return post(SUPPLIER_URL + '/supplierInfo/testSap', params)}
// 进入退出优先库申请 supplierInfo/firstApply
export function firstApply(params) {return post(SUPPLIER_URL + '/supplierInfo/firstApply', params)}
// supplierInfo/firstApprove  进入退出优先库执行审批
export function firstApprove(params) {return post(SUPPLIER_URL + '/supplierInfo/firstApprove', params)}
export function blacklistApply(params) {return post(SUPPLIER_URL + '/supplierInfo/blacklistApply', params)}
// supplierInfo/firstApprove  进入退出优先库执行审批
export function blacklistApprove(params) {return post(SUPPLIER_URL + '/supplierInfo/blacklistApprove', params)}

// supplierInfo/firstApprove  进入退出优先库执行审批
export function listInExitApplyPage(params) {return post(SUPPLIER_URL + '/admissionApplyForm/list', params)}


// 按供应商账号获取供应商信息
export function getSupplierByLoginName(params, pathParam) {return get(SUPPLIER_URL + '/supplierInfo/getSupplierByLoginName', params, pathParam)}


/** 供应商代码修改 */
// 供应代码申请查询
export function selectQualifiedCodeApplyPage(params) {return post(SUPPLIER_URL + '/qualifiedCodeApply/selectQualifiedCodeApplyPage', params)}
// 提交供应代码申请
export function applyQualifiedCode(params) {return post(SUPPLIER_URL + '/qualifiedCodeApply/applyQualifiedCode', params)}
// 根据供应商代码修改
export function updateSupplierCodeById(params) {return post(SUPPLIER_URL + '/qualifiedCodeApply/updateSupplierCodeById', params)}
// 发起一次性代码申请
export function supplierDisposableCodeApply(params) {return post(SUPPLIER_URL + '/qualifiedCodeApply/supplierDisposableCodeApply', params)}
export function checkVenderCode(params) {return post(SUPPLIER_URL + '/qualifiedCodeApply/checkVenderCode', params)}
// 合格代码审批
export function execTask3(params) {return post(SUPPLIER_URL + '/admissionApplyForm/executeApprove3', params)}
export function qmsSysState(params) {return post(SUPPLIER_URL + '/admissionApplyForm/qmsSysState', params)}
// 供应商变更审批
export function execTask4(params) {return post(SUPPLIER_URL + '/changeInfo/executeApprove4', params)}

// 供应商代码待申请待办的数量
export function countCodeApplyMyToDo(params) {return get(SUPPLIER_URL + '/qualifiedCodeApply/countCodeApplyMyToDo', params)}
// 供应商代码待申请待办的列表
export function listCodeApplyMyToDo(params) {return get(SUPPLIER_URL + '/qualifiedCodeApply/listCodeApplyMyToDo', params)}
// 生成供应商代码
export function createSupplierCode(params) {return get(SUPPLIER_URL + '/qualifiedCodeApply/createSupplierCode', params)}

export function test(params) {return post(SUPPLIER_URL + '/test/test', params)}
// 供应商主数据通过
export function synSAP(params) {return get(SUPPLIER_URL + '/supplierInfo/synSAP', params)}
// 供应商信息变更审批查询
export function selectChangeApprovePage(params) {return post(SUPPLIER_URL + '/changeInfo/selectChangeApprovePage', params)}

/** 通知公告管理 */
export function listNotice(params) {return post(SUPPLIER_URL + '/notice/list', params)}
export function qmsTodoCount(params, pathParam) {return get(SUPPLIER_URL + '/notice/qmsTodoCount', params, pathParam)}
export function qmsUrlData(params) {return post(SUPPLIER_URL + '/notice/qmsUrlData', params)}

export function getNotice(params, pathParam) {return get(SUPPLIER_URL + '/notice/getById', params, pathParam)}
export function addNotice(params) {return post(SUPPLIER_URL + '/notice/add', params)}
export function updateNotice(params) {return post(SUPPLIER_URL + '/notice/edit', params)}
export function delNotice(params, pathParam) {return post(SUPPLIER_URL + '/notice/deleteBatch', params, pathParam)}
export function sendNotice(params, pathParam) {return post(SUPPLIER_URL + '/notice/sendBatch', params, pathParam)}

//供应商绩效管理
export function exportTemplate() {return post(SUPPLIER_URL + '/supplierEva/exportTemplate')}
export function importSupplierEva(params) {return upload(SUPPLIER_URL + '/uploadFile/importSupplierEva', params)}
export function listSupplierEva(params) {return post(SUPPLIER_URL + '/supplierEva/list', params)}
export function getSupplierEvaList(params) {return post(SUPPLIER_URL + '/supplierEva/getSupplierEvaList', params)}
export function publishSupplierEva(params) {return post(SUPPLIER_URL + '/supplierEva/publishSupplierEva', params)}
export function cancelPublishSupplierEva(params) {return post(SUPPLIER_URL + '/supplierEva/cancelPublishSupplierEva', params)}
export function deleteSupplierEva(params) {return post(SUPPLIER_URL + '/supplierEva/deleteSupplierEva', params)}
export function getSupplierEva(params) {return post(SUPPLIER_URL + '/supplierEva/getSupplierEva', params)}

/** 供应商绩效导出 */
export function exportSupplierEvaData(params) {return post(SUPPLIER_URL + '/uploadFile/exportSupplierEvaDetail', params)}

/** 供应商扣分详情（5大类Tab） */
export function getSupplierPenaltyDetail(params) {return post(SUPPLIER_URL + '/supplierEva/getSupplierPenaltyDetail', params)}

//供应商索赔
export function exportCLATemplate() {return post(SUPPLIER_URL + '/supplierCla/exportTemplate')}
export function listSupplierCla(params) {return post(SUPPLIER_URL + '/supplierCla/list', params)}
export function importSupplierCla(params) {return upload(SUPPLIER_URL + '/uploadFile/importSupplierCla', params)}
export function getSupplierClaList(params) {return post(SUPPLIER_URL + '/supplierCla/getSupplierClaList', params)}
export function publishSupplierCla(params) {return post(SUPPLIER_URL + '/supplierCla/publishSupplierCla', params)}
export function cancelPublishSupplierCla(params) {return post(SUPPLIER_URL + '/supplierCla/cancelPublishSupplierCla', params)}
export function confirmSupplierCla(params) {return post(SUPPLIER_URL + '/supplierCla/confirmSupplierCla', params)}
export function deleteSupplierCla(params) {return post(SUPPLIER_URL + '/supplierCla/deleteSupplierCla', params)}
export function closeSupplierCla(params) {return post(SUPPLIER_URL + '/supplierCla/closeSupplierCla', params)}
export function getSupplierClaDetailList(params) {return post(SUPPLIER_URL + '/supplierCla/getSupplierClaDetailList', params)}
export function exportSupplierClaData(params) {return post(SUPPLIER_URL + '/uploadFile/exportSupplierClaDetail', params)}
export function batchPublishCla(params) {
    return post(SUPPLIER_URL + '/supplierCla/batchPublishCla', params)
}
export function batchCancelPublishCla(params) {
    return post(SUPPLIER_URL + '/supplierCla/batchCancelPublishCla', params)
}
export function batchDelete(params) {
    return post(SUPPLIER_URL + '/supplierCla/batchDelete', params)
}
//准入供应商查询

export function listSupplierInquiry(params) {return post(SUPPLIER_URL + '/supplierOa/list', params)}
//删除
export function listSupplierDelete(params) {return post(SUPPLIER_URL + '/supplierOa/delete', params)}

//修改
export function listSupplierUpdate(params) {return post(SUPPLIER_URL + '/supplierOa/update', params)}

export function complete(params) {return post(SUPPLIER_URL + '/supplierOa/complete', params)}
//查询当前登录人
export function roleSearch(params) {return post(SUPPLIER_URL + '/supplierOa/roleSearch', params)}
//notReceivedPlmTechCount
export function supplierAccessInquiry(params) {return get(SUPPLIER_URL + '/supplierOa/notReceivedPlmTechCount', params)}

//潜在供应商查询新增中的新增功能
export function supplierInquiryList(params) {return post(SUPPLIER_URL + '/supplierOa/list', params)}


//导出潜在供应商模板
export function exportSupplierInfoTemplate() {
    return post(SUPPLIER_URL + '/supplierInfo/exportTemplate')
}
//潜在供应商导入
export function importSupplierInfo(params) {
    return upload(SUPPLIER_URL + '/uploadFile/importSupplierInfo', params)
}


//supplierInfo/enableGroupSupplier  集团供应商启用
export function enableGroupSupplier(params) {return post(SUPPLIER_URL + '/supplierInfo/enableGroupSupplier', params)}

//supplierInfo/enableGroupSupplier  集团供应商启用
export function checkCertificateDate(params) {return post(SUPPLIER_URL + '/supplierInfo/checkCertificateDate', params)}


///supplierInfo/selectSupplierBLandSCPage
export function selectSupplierBLandSCPage(params) {return post(SUPPLIER_URL + '/supplierInfo/selectSupplierBLandSCPage', params)}

///supplierInfo/exportSupplierBLandSCData
export function exportSupplierBLandSCData(params) {return post(SUPPLIER_URL + '/supplierInfo/exportSupplierBLandSCData', params)}

export function searchByCompanyKey(params) {return post(SUPPLIER_URL + '/qcc/search', params)}

export function scanRisk(params) {return post(SUPPLIER_URL + '/qcc/scanRisk', params)}

export function rescanRisk(params) {return post(SUPPLIER_URL + '/qcc/rescanRisk', params)}

export function getSign(params) {return post(SUPPLIER_URL + '/qcc/getSign', params)}

export function getToken(params) {return post(SUPPLIER_URL + '/qcc/getToken', params)}

export function selectQccSupplier(params) {return post(SUPPLIER_URL + '/qcc/selectQccSupplier', params)}

export function selectBidding(params) {return post(SUPPLIER_URL + '/qcc/selectBidding', params)}

export function biddingScanRisk(params) {return post(SUPPLIER_URL + '/qcc/biddingScanRisk', params)}

/** 按产品名称查询供应商 */
export function listSupplierByProductName(params) {return post(SUPPLIER_URL + '/supplierInfo/listSupplierByProductName', params)}
